<script>
	import { debounce } from "lodash";
	import queryString from "query-string";
	import { convertDateTime } from "src/services/helpers";
	import { initPage } from "src/store/store";
	import { navigate } from "svelte-routing";
	import { Col, Row } from "sveltestrap";
	import CustomButton from "../../../../components/CustomButton/CustomButton.svelte";
	import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatePicker.svelte";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";
	import CustomSearch from "../../../../components/CustomSearch/CustomSearch.svelte";
	import DropdownCheckbox from "../../../../components/DropdownCheckbox/DropdownCheckbox.svelte";
	import LimitSize from "../../../../components/SizeSelect/limitSize.svelte";

	export let changeSearchParams = () => {};
	export let handleVehicleSearch = () => {};
	export let params = {};

	$: plateNo = "";
	let reviewer = "";
	let vehicleId = "";
	let verdict = "";
	let isOpen = false;
	let dateReviewed = "";

	$: options = [
		{
			id: 1,
			label: "New Damage",
			selected: false,
		},
		{
			id: 2,
			label: "No New Damage",
			selected: false,
		},
		{
			id: 0,
			label: "No Damage",
			selected: false,
		},
	];
	function handleChange(value) {
		changeSearchParams(value);
		initPage.set(1);
	}

	const resetFilter = () => {
		plateNo = "";
		reviewer = "";
		dateReviewed = "";
		let tab = queryString.parse(location.search).tab || 2;
		initPage.set(1);
		navigate("/issues/damage-validation" + `?tab=${tab}`);
		changeSearchParams("");
	};

	const toggle = () => {
		isOpen = !isOpen;
	};

	const debouncedInput = debounce((e) => handleChange(e), 1000);

	$: if (params.dateReviewed) {
		dateReviewed = params.dateReviewed;
	} else {
		dateReviewed = "";
	}

	$: if (params.verdict) {
		let verdicts = [];
		if (Array.isArray(params.verdict)) {
			verdicts = params.verdict.map((val) => parseInt(val));
		} else {
			verdicts = params.verdict.split(",").map((val) => parseInt(val));
		}
		options = options.map((val) => {
			if (verdicts.includes(val.id)) {
				val.selected = true;
			}
			return val;
		});
	} else {
		options = options.map((val) => {
			val.selected = false;
			return val;
		});
	}

	$: if (params.reviewer) {
		reviewer = params.reviewer;
	} else {
		reviewer = "";
	}

	$: if (params.plateNo && params.vehicleId) {
		plateNo = params.plateNo;
		vehicleId = params.vehicleId;
	} else {
		plateNo = "";
		vehicleId = "";
	}
</script>

<Row style="padding-right: 0">
	<Col xs={12}>
		<Row>
			<Col xs={10}>
				<Row>
					<Col xs={3}>
						<CustomDatePicker
							name="dateReviewed"
							placeholder={"Date Reviewed"}
							bind:value={dateReviewed}
							onChange={(e) =>
								handleChange({
									dateReviewed: e.detail,
								})}
							isRange={false}
						/>
					</Col>
					<Col xs={3}>
						<CustomSearch
							loadOptions={handleVehicleSearch}
							id={`plateNo`}
							type="text"
							placeholder={`Vehicle no.`}
							bind:value={plateNo}
							containerClasses={`search-icon`}
							onSelect={(e) => {
								plateNo = e.detail.label;
								vehicleId = e.detail.value;
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
							handleClear={() => {
								plateNo = "";
								vehicleId = "";
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
						/>
					</Col>
					<Col xs={3}>
						<CustomInput
							placeholder="Reviewer"
							search
							bind:value={reviewer}
							name="reviewer"
							onInput={(e) =>
								debouncedInput({
									[e.target.name]: e.target.value,
								})}
						/>
					</Col>
				</Row>
			</Col>
			<Col xs={2} style="position:relative; padding-right:0">
				<LimitSize />

				<!-- DONT FORGET TO CHANGE TO REAL DATE FROM BE -->
				<div class="d-flex flex-row justify-content-end">
					<span
						class="on-surface-variant"
						style="text-align: end; white-space: nowrap"
						>Last updated {convertDateTime(
							new Date(),
							"MMM D, h:mm A"
						)}</span
					>
				</div>
			</Col>
		</Row>
		<Row class="mb-3">
			<Col xs={10}>
				<Row>
					<Col xs={3}>
						<DropdownCheckbox
							categoryName="Verdict"
							{options}
							id="verdict"
							{isOpen}
							{toggle}
							refetch={handleChange}
						/>
					</Col>
					<Col class="d-flex align-items-center">
						<CustomButton
							style="border-color: transparent; font-weight: bold;"
							buttonText="Clear filters"
							onClick={resetFilter}
							color="secondary"
							onKeyDown={() => {}}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
	</Col>
</Row>
